export const itBackendMessages = {
  errors: {
    accountLocked: `Account temporaneamente bloccato a causa di più tentativi di accesso non riusciti. Riprova tra {{remaining_time}} minuti.`,
    accountLockedAttemptsRemaining: `L'email o la password non è corretta. Resta {{attempts_left_until_lock}} prima che l'account venga bloccato.`,
    accountLockedOneMoreAttempt: `L'email o la password non è corretta. Un altro tentativo fallito bloccherà l'account per 15 minuti.`,
    answerNotFound: `Nessuna risposta trovata per la domanda: {{question_key}}.`,
    answerQuestionKeyInvalid: `question_key non valido. Il formato deve essere "question_1" fino a "question_8".`,
    appleIapInvalidJson: `Payload JSON non valido`,
    appleIapMissingSignedPayload: `signedPayload mancante`,
    appleIapWebhookProcessingFailed: `Elaborazione del webhook non riuscita`,
    chatArchivalTaskFailed: `Impossibile accodare l'attività di archiviazione: {{error}}`,
    chatCeleryTestFailed: `Impossibile accodare le attività di test Celery: {{error}}`,
    chatQueryTooLong: `La richiesta è troppo lunga per essere elaborata.`,
    chatRulesRefreshFailed: `Aggiornamento delle regole della chat non riuscito: {{error}}`,
    chatSessionAlreadyClosed: `La sessione {{session_id}} è già chiusa`,
    chatSessionCloseAllFailed: `Impossibile chiudere le sessioni: {{error}}`,
    chatSessionCloseFailed: `Impossibile chiudere la sessione: {{error}}`,
    chatSessionGetActiveFailed: `Impossibile recuperare le sessioni attive: {{error}}`,
    chatSessionNotFound: `Sessione di chat non trovata`,
    chatStreamError: `Si è verificato un errore nel flusso della chat. Riprova.`,
    decryptionFailed: `Impossibile decrittografare i dati archiviati. Contatta l'assistenza.`,
    encryptionServiceNotConfigured: `Il servizio di crittografia non è configurato correttamente. Contatta l'assistenza.`,
    expiredProviderToken: `La sessione di accesso con Google o Apple è scaduta. Riprova.`,
    fileDocxExceedsSizeLimit: `Il file DOCX supera il limite di dimensione.`,
    fileImageExceedsSizeLimit: `L'immagine supera il limite di dimensione.`,
    fileImageTypeNotAllowed: `Tipo di immagine {{subtype}} non consentito.`,
    fileInsufficientPermissions: `Autorizzazioni insufficienti.`,
    fileNotFound: `File non trovato.`,
    filePdfExceedsSizeLimit: `Il file PDF supera il limite di dimensione.`,
    fileReadFailed: `Impossibile leggere il file: {{error}}`,
    fileSizeExceedsLimit: `La dimensione del file supera il limite massimo consentito di {{max_files}} MB.`,
    fileTooManyFiles: `Troppi file. Un massimo di {{max_size}} file è consentito per upload.`,
    fileTooManyFilesAttached: `Troppi allegati. È consentito un massimo di {{max_files}} file per messaggio.`,
    fileTypeNotAllowed: `Il tipo di file {{file_type}} non è consentito`,
    fileUploadAzureFailed: `Caricamento del file su Azure non riuscito`,
    fileUploadFailed: `Caricamento non riuscito: {{error}}`,
    googlePlayInvalidBase64Json: `Base64/JSON non valido: {{error}}`,
    googlePlayInvalidEnvelope: `Busta non valida: {{error}}`,
    googlePlayMissingMessageIdOrData: `messageId o dati mancanti`,
    googlePlayMissingRequiredFields: `Campi RTDN obbligatori mancanti`,
    googlePlayPackageNameRequired: `È richiesto il nome del pacchetto`,
    googlePlayPackageNotAllowed: `Il pacchetto {{package_name}} non è consentito`,
    googlePlayProcessingFailed: `Elaborazione non riuscita: {{error}}`,
    googlePlayProductIdRequired: `L'ID prodotto è obbligatorio nei dettagli d'acquisto`,
    googlePlayPurchaseDetailsRequired: `I dettagli dell'acquisto sono obbligatori`,
    googlePlayPurchaseTokenRequired: `È richiesto il token d'acquisto`,
    googlePlayPurchaseVerificationFailed: `Verifica dell'acquisto non riuscita: {{message}}`,
    googlePlayPurchaseVerificationFailedUnexpected: `Verifica dell'acquisto non riuscita a causa di un errore imprevisto.`,
    googlePlayServiceConfigurationError: `Errore di configurazione del servizio Google Play: {{error}}`,
    incorrectEmailOrPassword: `L'email o la password non è corretta.`,
    incorrectPassword: `La password non è corretta.`,
    internalServerError: `Errore interno del server.`,
    invalidProviderToken: `Impossibile verificare l’accesso con Google o Apple. Riprova.`,
    invalidRefreshToken: `Token di aggiornamento non valido.`,
    invalidToken: `Token non valido.`,
    invalidTokenType: `Tipo di token non valido.`,
    notAuthenticated: `Autenticazione non riuscita.`,
    couldNotValidateCredentials: `Impossibile convalidare le credenziali.`,
    accountInactive: `L'account è inattivo o programmato per l'eliminazione.`,
    providerAuthFailed: `L’accesso tramite il tuo provider non è riuscito. Riprova oppure usa e-mail e password.`,
    unsupportedProvider: `Questo provider di accesso non è supportato.`,
    linkingRequired: `Questa identità social deve essere collegata a un account HARVN esistente prima di poter continuare.`,
    accountLinkingFailed: `Non siamo riusciti a collegare questa identità social al tuo account HARVN. Verifica i dati e riprova.`,
    providerUnavailable: `L’accesso social non è temporaneamente disponibile. Usa e-mail e password.`,
    onboardingIncomplete: `Il tuo account non è ancora completamente configurato. Completa i passaggi richiesti prima di continuare.`,
    accountCompletionNotRequired: `Il tuo account è già completo. Puoi continuare a usare HARVN normalmente.`,
    tokenExpired: `Il token è scaduto.`,
    tokenRevoked: `Il token è stato revocato.`,
    tokenLimitExceeded: `Limite token superato.`,
    debugTokenCheckFailed: `Errore durante il controllo del token: {{error}}`,
    passwordResetEmailFailed: `Impossibile inviare l'e-mail di reimpostazione della password. Riprova più tardi.`,
    passwordSameAsCurrent: `La nuova password non può coincidere con quella attuale`,
    passwordsDontMatch: `Le password non corrispondono.`,
    questionnaireNotFound: `Questionario non trovato.`,
    rateLimitExceeded: `Limite di richieste superato: {{limit_str}}.`,
    assistantPromptNotFound: `Prompt dell'assistente non trovato`,
    assistantPromptNotAuthorized: `Non autorizzato ad accedere a questo prompt`,
    assistantPromptNotAuthorizedToActivate: `Non autorizzato ad attivare questo prompt`,
    assistantPromptNotAuthorizedToDelete: `Non autorizzato ad eliminare questo prompt`,
    assistantPromptNotAuthorizedToUpdate: `Non autorizzato ad aggiornare questo prompt`,
    validationDateInvalid: `Formato data non valido.`,
    validationEmailInvalid: `Formato indirizzo e-mail non valido.`,
    validationFieldRequired: `Campo obbligatorio.`,
    validationGeneric: `Errore di convalida.`,
    validationInvalidValue: `Valore non valido.`,
    validationPasswordLength: `La password deve contenere tra 8 e 40 caratteri.`,
    validationStringTooLong: `Il valore è troppo lungo.`,
    validationStringTooShort: `Il valore è troppo corto.`,
    validationTypeError: `Tipo non valido.`,
    validationValueOutOfRange: `Valore fuori dall'intervallo consentito.`,
    rateLimitRetryAfter: `Limite di richieste raggiunto. Riprova {{retry_after_formatted}}.`,
    subscriptionAdminPrivilegesRequired: `Sono necessari privilegi amministratore.`,
    subscriptionAlreadyActive: `L'utente ha già un abbonamento attivo.`,
    subscriptionCancelled: `Il tuo abbonamento è stato annullato. Reattiva l'abbonamento per continuare.`,
    subscriptionCancelFailed: `Impossibile annullare l'abbonamento.`,
    subscriptionCannotDowngrade: `È presente un abbonamento attivo — downgrade non disponibile.`,
    subscriptionCannotSwitchToSamePlan: `Non è possibile passare allo stesso piano di abbonamento.`,
    subscriptionDaysAdvanceLimit: `Non è possibile avanzare di oltre 365 giorni in una sola volta.`,
    subscriptionDayConsumptionFreemiumOnly: `L'uso giornaliero è disponibile solo per gli utenti in freemium trial.`,
    subscriptionDaysMustBePositive: `I giorni utilizzati devono essere positivi.`,
    subscriptionFreemiumActivationFailed: `Impossibile attivare il periodo di prova gratuita.`,
    subscriptionFreemiumExpired: `Il periodo di prova gratuita è terminato. `,
    subscriptionFreemiumTrialEnded: `Il periodo di prova gratuita è terminato. Abbonati per continuare.`,
    subscriptionFreemiumTokensExhausted: `Hai utilizzato tutti i token della prova gratuita. Abbonati per continuare.`,
    subscriptionExpired: `Il tuo abbonamento è scaduto. Abbonati di nuovo.`,
    subscriptionInvalidPlanChoice: `Scelta piano non valida. Devi selezionare un piano Mensile o Annuale.`,
    subscriptionInvalidStatus: `Stato dell'abbonamento non valido.`,
    subscriptionNoActiveSubscription: `Nessun abbonamento attivo trovato.`,
    subscriptionNotEnoughTokensRemaining: `Token rimanenti insufficienti.`,
    subscriptionPaymentConfigurationError: `Errore di configurazione del pagamento. Contatta l'assistenza.`,
    subscriptionPaymentProcessingError: `Errore di elaborazione del pagamento: {{error}}.`,
    subscriptionPeriodEnded: `Il tuo abbonamento è scaduto. Abbonati di nuovo.`,
    subscriptionStripeConfigurationError: `Errore di configurazione di Stripe: {{error}}.`,
    subscriptionStripeNotAvailable: `Stripe non disponibile.`,
    subscriptionStripeNotConfigured: `Stripe non configurato.`,
    subscriptionTrialNotInitialized: `Periodo di prova non inizializzato.`,
    subscriptionUserAlreadyHasActiveSubscription: `L'utente ha già un abbonamento attivo`,
    subscriptionNoStripeSubscriptionForBillingPortal: `Il metodo di pagamento può essere aggiornato solo per gli abbonamenti attivi. Nessun abbonamento attivo trovato.`,
    subscriptionNotFound: `Abbonamento non trovato`,
    subscriptionTokensMustBePositive: `I token utilizzati devono essere positivi.`,
    subscriptionWebhookInvalidPayload: `Payload non valido`,
    subscriptionWebhookInvalidSignature: `Firma non valida`,
    subscriptionWebhookMissingSignature: `Header stripe-signature mancante`,
    subscriptionWebhookSecretNotConfigured: `Segreto del webhook non configurato`,
    tokenAlreadyUsed: `Token già utilizzato.`,
    tokenNotFound: `Token non trovato.`,
    tooManyLoginAttempts: `Troppi tentativi di accesso. Riprova tra {{retry_after}} secondi. {{attempts_left_until_lock}} prima del blocco dell'account.`,
    unexpectedError: `Si è verificato un errore imprevisto. Riprova più tardi.`,
    userAccountCreationFailed: `Impossibile creare l'account. Riprova o accedi se hai già un account.`,
    userCannotDeleteSelf: `I super-user non possono eliminare il proprio account.`,
    userDeletionFailed: `Impossibile programmare l'eliminazione dell'account. Riprova più tardi.`,
    userEmailAlreadyVerified: `Email già verificata.`,
    userEmailExists: `Impossibile aggiornare l'email. Prova con un'altra.`,
    userEmailNotVerified: `Indirizzo email non verificato.`,
    userEmailUpdateFailed: `Impossibile aggiornare l'email. Prova con un'altra.`,
    userInactive: `Utente inattivo.`,
    userInsufficientPrivileges: `L'utente non dispone dei privilegi necessari.`,
    userNotAllowed: `Utente non autorizzato.`,
    userNotFound: `Utente non trovato.`,
    userPrivacyNotAccepted: `Per creare un account è necessario accettare l'Informativa sulla Privacy.`,
    userTermsNotAccepted: `Per creare un account è necessario accettare i Termini di Servizio.`,
    userWithEmailNotFound: `Nessun utente trovato con questa email.`,
    userWithIdNotFound: `Nessun utente trovato con questo ID.`,
    userWithUsernameNotFound: `Nessun utente trovato con questo nome utente.`,
  },
  success: {
    accountScheduledForDeletion: `Il tuo account è stato programmato per l'eliminazione.`,
    fileDeleted: `File eliminato correttamente`,
    fileUploaded: `File caricato correttamente su Azure Blob Storage`,
    fileUploadedToSession: `File caricato correttamente nello storage della sessione`,
    fileUploadUrlGenerated: `URL di caricamento generato correttamente`,
    loggedOut: `Disconnessione eseguita`,
    passwordRecoveryEmailSent: `Email di recupero password inviata`,
    passwordUpdated: `Password aggiornata correttamente`,
    sessionClosed: `Sessione {{session_id}} chiusa e accodata per l'archiviazione`,
    userDeleted: `Utente eliminato correttamente`,
    userVerified: `Utente verificato correttamente`,
    verificationEmailSent: `Email di verifica reinviata correttamente`,
  },
} as const;
